import { useState } from 'react';
import Sidebar from '../components/Sidebar';

interface StyleAlbum {
  id: string;
  customerName: string;
  weddingDate: string;
  rehearsalStyle: {
    title: string;
    description: string;
    photo: string;
  } | null;
  weddingStyle: {
    title: string;
    description: string;
    photo: string;
  } | null;
  referenceImages: {
    id: string;
    title: string;
    photo: string;
  }[];
}

export default function MakeupGallery() {
  const [selectedAlbum, setSelectedAlbum] = useState<string | null>('1');
  const [showAddImageModal, setShowAddImageModal] = useState(false);

  const [albums, setAlbums] = useState<StyleAlbum[]>([
    {
      id: '1',
      customerName: '김미영',
      weddingDate: '2024-03-25',
      rehearsalStyle: {
        title: '세미글램 스타일',
        description: '자연스러운 피부 표현과 코랄핑크 립으로 화사한 이미지 연출',
        photo: 'https://readdy.ai/api/search-image?query=elegant%20natural%20bridal%20makeup%20with%20soft%20pink%20lips%20and%20natural%20eyebrows%20on%20fair%20skin%20bride%20wearing%20white%20dress%20in%20bright%20studio%20setting%20professional%20beauty%20photography%20clean%20white%20background&width=600&height=600&seq=style1&orientation=squarish'
      },
      weddingStyle: {
        title: '내추럴 글로우',
        description: '촉촉한 피부 표현과 자연스러운 컬러감으로 순수한 신부 이미지',
        photo: 'https://readdy.ai/api/search-image?query=natural%20glowing%20bridal%20makeup%20with%20dewy%20skin%20and%20soft%20coral%20lips%20elegant%20bride%20in%20white%20wedding%20dress%20professional%20wedding%20photography%20clean%20white%20background&width=600&height=600&seq=style2&orientation=squarish'
      },
      referenceImages: [
        {
          id: 'ref1',
          title: '선호 립 컬러 레퍼런스',
          photo: 'https://readdy.ai/api/search-image?query=coral%20pink%20lip%20color%20reference%20for%20bridal%20makeup%20close%20up%20beauty%20shot%20professional%20makeup%20photography%20clean%20white%20background&width=400&height=400&seq=ref1&orientation=squarish'
        },
        {
          id: 'ref2',
          title: '눈썹 스타일 레퍼런스',
          photo: 'https://readdy.ai/api/search-image?query=natural%20arched%20eyebrow%20style%20for%20bride%20close%20up%20beauty%20reference%20professional%20makeup%20photography%20clean%20white%20background&width=400&height=400&seq=ref2&orientation=squarish'
        }
      ]
    },
    {
      id: '2',
      customerName: '이지은',
      weddingDate: '2024-04-10',
      rehearsalStyle: null,
      weddingStyle: {
        title: '글램 스타일',
        description: '또렷한 눈매와 레드브라운 립으로 강렬한 이미지 연출',
        photo: 'https://readdy.ai/api/search-image?query=glamorous%20bridal%20makeup%20with%20bold%20eyes%20and%20red%20brown%20lips%20sophisticated%20bride%20in%20ivory%20dress%20professional%20wedding%20photography%20clean%20white%20background&width=600&height=600&seq=style3&orientation=squarish'
      },
      referenceImages: [
        {
          id: 'ref3',
          title: '글램 아이 메이크업',
          photo: 'https://readdy.ai/api/search-image?query=glamorous%20eye%20makeup%20for%20bride%20with%20defined%20eyeliner%20and%20lashes%20close%20up%20beauty%20shot%20professional%20makeup%20photography%20clean%20white%20background&width=400&height=400&seq=ref3&orientation=squarish'
        }
      ]
    },
    {
      id: '3',
      customerName: '박수진',
      weddingDate: '2024-03-30',
      rehearsalStyle: {
        title: '클래식 스타일',
        description: '우아한 피부 표현과 로즈핑크 립으로 고급스러운 이미지',
        photo: 'https://readdy.ai/api/search-image?query=classic%20elegant%20bridal%20makeup%20with%20rose%20pink%20lips%20and%20soft%20arched%20eyebrows%20sophisticated%20beauty%20look%20on%20bride%20in%20white%20ballgown%20professional%20wedding%20photography%20clean%20white%20background&width=600&height=600&seq=style4&orientation=squarish'
      },
      weddingStyle: {
        title: '클래식 엘레강스',
        description: '부드러운 아치형 눈썹과 로즈핑크 립으로 우아한 신부 이미지',
        photo: 'https://readdy.ai/api/search-image?query=classic%20elegant%20wedding%20makeup%20with%20soft%20features%20and%20rose%20pink%20lips%20timeless%20bridal%20beauty%20in%20white%20dress%20professional%20photography%20clean%20white%20background&width=600&height=600&seq=style5&orientation=squarish'
      },
      referenceImages: []
    }
  ]);

  const selectedAlbumData = albums.find(a => a.id === selectedAlbum);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 overflow-auto p-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">스타일 갤러리</h1>
            <p className="text-sm text-gray-600 mt-1">고객별 메이크업 스타일을 기록하고 관리하세요</p>
          </div>
          <button
            onClick={() => setShowAddImageModal(true)}
            className="bg-pink-600 text-white px-4 py-2 rounded-lg hover:bg-pink-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-image-add-line mr-2"></i>
            이미지 추가
          </button>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {/* 고객 목록 */}
          <div className="col-span-3">
            <div className="bg-white rounded-lg shadow p-4">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">고객 목록</h3>
              <div className="space-y-2">
                {albums.map((album) => (
                  <div
                    key={album.id}
                    onClick={() => setSelectedAlbum(album.id)}
                    className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
                      selectedAlbum === album.id
                        ? 'border-pink-500 bg-pink-50'
                        : 'border-gray-200 hover:border-pink-300'
                    }`}
                  >
                    <h4 className="font-semibold text-gray-900">{album.customerName}</h4>
                    <p className="text-sm text-gray-600 mt-1">{album.weddingDate}</p>
                    <div className="flex items-center gap-2 mt-2 text-xs text-gray-500">
                      <span>{album.rehearsalStyle ? '리허설 ✓' : '리허설 -'}</span>
                      <span>•</span>
                      <span>{album.weddingStyle ? '본식 ✓' : '본식 -'}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 스타일 갤러리 */}
          <div className="col-span-9">
            {selectedAlbumData ? (
              <div className="space-y-6">
                {/* 고객 정보 */}
                <div className="bg-white rounded-lg shadow p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h2 className="text-2xl font-bold text-gray-900">{selectedAlbumData.customerName}</h2>
                      <p className="text-gray-600 mt-1">예식일: {selectedAlbumData.weddingDate}</p>
                    </div>
                    <div className="flex gap-2">
                      <button className="px-4 py-2 bg-pink-50 text-pink-600 rounded-lg hover:bg-pink-100 transition-colors whitespace-nowrap cursor-pointer">
                        <i className="ri-share-line mr-2"></i>
                        고객과 공유
                      </button>
                    </div>
                  </div>
                </div>

                {/* 리허설 스타일 */}
                {selectedAlbumData.rehearsalStyle && (
                  <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-image-line text-purple-600 w-5 h-5 flex items-center justify-center"></i>
                      리허설 메이크업
                    </h3>
                    <div className="grid grid-cols-2 gap-6">
                      <div>
                        <img
                          src={selectedAlbumData.rehearsalStyle.photo}
                          alt="리허설 메이크업"
                          className="w-full rounded-lg shadow-md object-cover object-top"
                        />
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">
                          {selectedAlbumData.rehearsalStyle.title}
                        </h4>
                        <p className="text-gray-600 leading-relaxed">
                          {selectedAlbumData.rehearsalStyle.description}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* 본식 스타일 */}
                {selectedAlbumData.weddingStyle && (
                  <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-image-line text-pink-600 w-5 h-5 flex items-center justify-center"></i>
                      본식 메이크업
                    </h3>
                    <div className="grid grid-cols-2 gap-6">
                      <div>
                        <img
                          src={selectedAlbumData.weddingStyle.photo}
                          alt="본식 메이크업"
                          className="w-full rounded-lg shadow-md object-cover object-top"
                        />
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">
                          {selectedAlbumData.weddingStyle.title}
                        </h4>
                        <p className="text-gray-600 leading-relaxed">
                          {selectedAlbumData.weddingStyle.description}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* 스타일 비교 */}
                {selectedAlbumData.rehearsalStyle && selectedAlbumData.weddingStyle && (
                  <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-contrast-line text-blue-600 w-5 h-5 flex items-center justify-center"></i>
                      리허설 vs 본식 비교
                    </h3>
                    <div className="grid grid-cols-2 gap-6">
                      <div>
                        <div className="text-sm font-medium text-gray-600 mb-2">리허설 스타일</div>
                        <img
                          src={selectedAlbumData.rehearsalStyle.photo}
                          alt="리허설"
                          className="w-full rounded-lg shadow-md object-cover object-top"
                        />
                        <p className="text-sm text-gray-600 mt-2">{selectedAlbumData.rehearsalStyle.title}</p>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-gray-600 mb-2">본식 스타일</div>
                        <img
                          src={selectedAlbumData.weddingStyle.photo}
                          alt="본식"
                          className="w-full rounded-lg shadow-md object-cover object-top"
                        />
                        <p className="text-sm text-gray-600 mt-2">{selectedAlbumData.weddingStyle.title}</p>
                      </div>
                    </div>
                  </div>
                )}

                {/* 레퍼런스 이미지 */}
                {selectedAlbumData.referenceImages.length > 0 && (
                  <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-gallery-line text-orange-600 w-5 h-5 flex items-center justify-center"></i>
                      스타일 레퍼런스
                    </h3>
                    <div className="grid grid-cols-3 gap-4">
                      {selectedAlbumData.referenceImages.map((image) => (
                        <div key={image.id} className="group">
                          <img
                            src={image.photo}
                            alt={image.title}
                            className="w-full rounded-lg shadow-md object-cover object-top group-hover:shadow-lg transition-shadow"
                          />
                          <p className="text-sm text-gray-600 mt-2">{image.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="bg-white rounded-lg shadow p-12 text-center">
                <i className="ri-gallery-line text-4xl text-gray-300 mb-4"></i>
                <p className="text-gray-500">고객을 선택하세요</p>
              </div>
            )}
          </div>
        </div>

        {/* 이미지 추가 모달 */}
        {showAddImageModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 w-full max-w-lg">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">스타일 이미지 추가</h2>
                <button
                  onClick={() => setShowAddImageModal(false)}
                  className="text-gray-500 hover:text-gray-700 w-6 h-6 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>
              
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">고객 선택</label>
                  <select className="w-full border border-gray-300 rounded-md px-3 py-2 pr-8 cursor-pointer">
                    {albums.map(album => (
                      <option key={album.id} value={album.id}>{album.customerName}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">이미지 유형</label>
                  <select className="w-full border border-gray-300 rounded-md px-3 py-2 pr-8 cursor-pointer">
                    <option value="rehearsal">리허설 메이크업</option>
                    <option value="wedding">본식 메이크업</option>
                    <option value="reference">레퍼런스 이미지</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">제목</label>
                  <input 
                    type="text" 
                    placeholder="스타일 제목"
                    className="w-full border border-gray-300 rounded-md px-3 py-2" 
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">설명</label>
                  <textarea 
                    maxLength={500}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 h-20 resize-none"
                    placeholder="스타일 설명"
                  ></textarea>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">이미지 URL</label>
                  <input 
                    type="text" 
                    placeholder="이미지 URL을 입력하세요"
                    className="w-full border border-gray-300 rounded-md px-3 py-2" 
                  />
                </div>
                
                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={() => setShowAddImageModal(false)}
                    className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 whitespace-nowrap cursor-pointer"
                  >
                    취소
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-pink-600 text-white rounded-md hover:bg-pink-700 whitespace-nowrap cursor-pointer"
                  >
                    추가
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
